export default __webpack_public_path__ + "static/map-dd42d6ef2a5c806fb92ce80d2865afbb.png";